import { usePagination } from '@fourthwall/components'

import type { PromotionCreationReason } from '../PromotionCodes.types'
import { PER_PAGE } from '../consts'
import { useFilterPromotionCodes } from '../modules/PromotionCodesFilter'
import { usePromotionsQuery } from '../queries/usePromotionsQuery'

export const usePromotionCodes = () => {
  const { filtersParams } = useFilterPromotionCodes()
  const [currentPage] = usePagination()

  const { promotionsQuery } = usePromotionsQuery(
    [
      {
        page: currentPage - 1,
        size: PER_PAGE,
        creationReasons: (filtersParams.creationReason as PromotionCreationReason) || ['MANUAL'],
      },
    ],
    {
      keepPreviousData: true,
    },
  )

  return {
    data: promotionsQuery.data?.promotions || [],
    isLoading: promotionsQuery.isFetching,
    totalPages: promotionsQuery.data?.page?.totalPages || 0,
  }
}
